"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created on Fri Oct 26 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowTypeConverter.
 *
 * @author ZSt
 */


var WindowTypeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowTypeConverter, _DataObjectConverter_);

  function WindowTypeConverter() {
    _classCallCheck(this, WindowTypeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowTypeConverter).apply(this, arguments));
  }

  return WindowTypeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowTypeConverter = WindowTypeConverter;